module.exports = __webpack_public_path__ + "static/media/upload-image5.490b28d4.svg";